var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "media-uploader",
        "upload-image",
        {
          "pointer-events-none": _vm.disableMouseEventsData,
          "media-uploader--disabled": _vm.isDisabled,
        },
      ],
    },
    [
      _c(
        "div",
        { class: { "panelar py-4": _vm.isLegacy } },
        [
          _vm.privacyPolicyEnabled
            ? [
                _vm.savedImagesLoadingComplete && _vm.enabledPhotoFlag
                  ? _c("div", { staticClass: "form-row" }, [
                      _c("div", { staticClass: "form-group col-md-1 mb-0" }, [
                        _c(
                          "label",
                          {
                            ref: "uploadFlagLabel",
                            staticClass: "switch switch-left-right mb-0",
                            attrs: {
                              for: "boxphoto",
                              "data-content": _vm.i18n.acceptToUpload,
                              "data-toggle": "popover",
                              "data-placement": "bottom",
                              "data-trigger": "focus",
                            },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.uploadFlag,
                                  expression: "uploadFlag",
                                },
                              ],
                              ref: "uploadFlag",
                              staticClass: "switch-input form-control",
                              attrs: {
                                name: "photo_flag",
                                id: "boxphoto",
                                type: "checkbox",
                                value: "on",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.uploadFlag)
                                  ? _vm._i(_vm.uploadFlag, "on") > -1
                                  : _vm.uploadFlag,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.uploadFlag,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "on",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.uploadFlag = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.uploadFlag = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.uploadFlag = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "switch-label",
                              attrs: {
                                "data-on": _vm.i18n.yes,
                                "data-off": _vm.i18n.no,
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "switch-handle" }),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-10 txt_privacy pt-2" }, [
                  _vm.countryCode === "BR"
                    ? _c("p", [
                        _c("strong", [
                          _vm._v(
                            "\n                            Ao submeter o anúncio, o usuário declara ser maior de 18 anos e concorda que será o\n                            único responsável pela veracidade das informações e imagens enviadas à Plataforma\n                            SKOKKA.\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n                            O envio de imagens e dados não autorizados por seus titulares é absolutamente vedado e causará a\n                            remoção do anúncio. O usuário está sujeito às penalidades cabíveis na\n                            esfera cível e criminal por eventuais danos ou prejuízos causados pelas informações\n                            inseridas na plataforma, inclusive perante terceiros.\n                    "
                        ),
                      ])
                    : _c("p", {
                        domProps: { innerHTML: _vm._s(_vm.i18n.privacyText) },
                      }),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.editImagesOnlyMessage
            ? _c("ui-alert", {
                attrs: {
                  title: _vm.i18n.activePromotion,
                  description: _vm.i18n.canOnlyEditYourPhotos,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { ref: "imageBox" },
            [
              _vm.savedImagesLoadingComplete &&
              _vm.imagesArray.length > 1 &&
              !_vm.forceDisableSorting
                ? _c("ui-alert", {
                    staticClass: "onlydk",
                    attrs: {
                      dismissable: "",
                      description: _vm.i18n.alertSavedImagesLoadingComplete,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.savedImagesLoadingProgress < 100
                ? _c("uploader-progress", {
                    staticClass: "h-100",
                    attrs: { progress: _vm.savedImagesLoadingProgress },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "draggable",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.savedImagesLoadingProgress === 100,
                      expression: "savedImagesLoadingProgress === 100",
                    },
                  ],
                  staticClass: "row",
                  attrs: {
                    draggable: ".draggable-image-editor",
                    "force-fallback": _vm.draggableForceFallback,
                    "ghost-class": "sortable-ghost",
                    disabled: _vm.disableSorting,
                    "flag-disable": _vm.imageFlagDisable,
                    filter: ".no-drag",
                  },
                  model: {
                    value: _vm.imagesArray,
                    callback: function ($$v) {
                      _vm.imagesArray = $$v
                    },
                    expression: "imagesArray",
                  },
                },
                [
                  _vm._l(_vm.imagesArray, function (image, index) {
                    return _c("image-editor", {
                      key: image.uuid,
                      staticClass:
                        "col-xs-6 col-sm-6 col-md-3 mb-3 h-100 draggable-image-editor",
                      style: _vm.disableSorting ? "box-shadow:none;" : "",
                      attrs: {
                        "image-src": image.src,
                        "image-src-version": {
                          name: _vm.imageSrcVersionName,
                          value: _vm.imageSrcVersionValue,
                        },
                        "image-browser-src": _vm.browserImages[image.uuid]
                          ? _vm.browserImages[image.uuid].browserSrc
                          : null,
                        "is-cover": image.isCover,
                        "is-allowed": image.isAllowed,
                        "disable-sorting": _vm.disableSorting,
                        "initial-rotation": image.rotate,
                        "initial-crop": image.crop,
                        "initial-allowed": image.is_allowed,
                        "flag-disable": _vm.imageFlagDisable,
                        "cropper-modal-image-max-width": _vm.imageMaxSizeWidth,
                        "cropper-modal-image-max-height":
                          _vm.imageMaxSizeHeight,
                        "too-small-alert-message": _vm.i18n.imageTooSmall,
                        "image-not-allowed-message": _vm.i18n.imageNotAllowed,
                        "image-not-allowed-preview-message":
                          _vm.i18n.imageNotAllowedPreview,
                        "one-image-free-ad-alert": _vm.oneImageFreeAdAlert,
                        "post-promote-url": _vm.postPromoteUrl
                          ? _vm.postPromoteEncoded
                          : null,
                        "is-update": _vm.isUpdate,
                        "disable-crop": _vm.disableCrop,
                        "disable-rotate": _vm.disableRotate,
                        "disable-preview-header": _vm.disablePreviewHeader,
                      },
                      on: {
                        "image-load-completed": function ($event) {
                          var i = arguments.length,
                            argsArray = Array(i)
                          while (i--) argsArray[i] = arguments[i]
                          return _vm.onImageLoadCompleted.apply(
                            void 0,
                            [image.uuid].concat(argsArray)
                          )
                        },
                        "remove-image": function ($event) {
                          return _vm.deleteImage(index)
                        },
                        "set-cover": function ($event) {
                          return _vm.setCover(index)
                        },
                        "updated-edit-data": function ($event) {
                          var i = arguments.length,
                            argsArray = Array(i)
                          while (i--) argsArray[i] = arguments[i]
                          return _vm.updateImageEditData.apply(
                            void 0,
                            [index].concat(argsArray)
                          )
                        },
                        "cropper-modal-shown": function ($event) {
                          return _vm.cropperModalShown(index)
                        },
                        "cropper-modal-hidden": function ($event) {
                          return _vm.cropperModalHidden(index)
                        },
                        "client-size-data": function ($event) {
                          var i = arguments.length,
                            argsArray = Array(i)
                          while (i--) argsArray[i] = arguments[i]
                          return _vm.onClientSizeData.apply(
                            void 0,
                            [image.uuid].concat(argsArray)
                          )
                        },
                      },
                    })
                  }),
                  _vm._v(" "),
                  _vm.imagesArray.length < _vm.initNumberOfAllowedImages
                    ? _c(
                        "div",
                        {
                          class:
                            _vm.imagesArray.length === 0
                              ? "col-12"
                              : "col-md-3 col-xs-6 col-sm-6",
                          style: _vm.uploadBoxStyle,
                        },
                        [
                          _vm.isUploading
                            ? _c("uploader-progress", {
                                staticClass: "h-100",
                                attrs: { progress: _vm.uploadProgress },
                              })
                            : _c(
                                "div",
                                {
                                  ref: "uploadDropZone",
                                  staticClass:
                                    "media-uploader__drop-zone border-with-dashed",
                                  on: {
                                    dragover: function ($event) {
                                      $event.preventDefault()
                                    },
                                    drop: _vm.handleFileDrop,
                                  },
                                },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "media-uploader__label" },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "media-uploader__text media-uploader__text--uppercase media-uploader__text--with-counter",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.uploadableImagesText
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "media-uploader__camera-icon fa fa-camera fa-2x",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "media-uploader__text media-uploader__text--capitalize",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "txtnomobile" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.i18n
                                                    .dragAndDropInstructionsNoMobile
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.i18n.dragAndDropInstructions
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        staticClass: "upload",
                                        attrs: {
                                          id: "upload",
                                          accept: _vm.acceptedType,
                                          type: "file",
                                          multiple: "",
                                        },
                                        on: { change: _vm.loadImageInput },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _vm.isLegacy && _vm.savedImagesLoadingComplete
                ? _c(
                    "div",
                    { staticClass: "panel-heading text-center" },
                    [
                      _c("p", { staticClass: "small mb-3" }, [
                        _vm._v(_vm._s(_vm.i18n.loadingCompleteMessage)),
                      ]),
                      _vm._v(" "),
                      _vm.oneImageFreeAdAlert
                        ? _c("ui-alert", {
                            attrs: {
                              description: _vm.i18n.onlyOnePictureForFreeAds,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "lightboxInvalidImage",
              staticClass: "modal",
              attrs: { tabindex: "-1", "data-backdrop": "static" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal-dialog modal-dialog-centered",
                  attrs: { role: "document" },
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title text-uppercase" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.i18n.modalInvalidImageTitle) +
                            ":\n                        "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column bd-highlight mb-3" },
                        [
                          _c("div", { staticClass: "p-2 bd-highlight" }, [
                            _vm.lightboxInvalidImageMessageContent
                              ? _c("span", [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.lightboxInvalidImageMessageContent
                                      ) +
                                      "\n                                "
                                  ),
                                ])
                              : _vm.lightboxInvalidImageErrorCodes.size > 0
                              ? _c("span", [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.i18n.modalImagesNotSaved)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.lightboxInvalidImageErrorCodes.has(
                                            _vm.ERROR_CODE_INVALID_FORMAT
                                          ),
                                        expression:
                                          "lightboxInvalidImageErrorCodes.has(ERROR_CODE_INVALID_FORMAT)",
                                      },
                                    ],
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.modalImageNotSavedInstructionsText
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.lightboxInvalidImageErrorCodes.has(
                                            _vm.ERROR_CODE_INVALID_FORMAT
                                          ),
                                        expression:
                                          "lightboxInvalidImageErrorCodes.has(ERROR_CODE_INVALID_FORMAT)",
                                      },
                                    ],
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.i18n.modalImageNotSavedInstructions1
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.lightboxInvalidImageErrorCodes.has(
                                              _vm.ERROR_CODE_INVALID_CONTENT
                                            ),
                                          expression:
                                            "lightboxInvalidImageErrorCodes.has(ERROR_CODE_INVALID_CONTENT)",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.i18n
                                            .modalImageNotSavedInstructions2
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.lightboxInvalidImageErrorCodes.has(
                                              _vm.ERROR_CODE_MULTIPLE_FACES
                                            ),
                                          expression:
                                            "lightboxInvalidImageErrorCodes.has(ERROR_CODE_MULTIPLE_FACES)",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.i18n
                                            .modalImageNotSavedInstructions3
                                        )
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("span", [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.i18n.modalImagesNotSaved)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.modalImageNotSavedInstructionsText
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.i18n.modalImageNotSavedInstructions1
                                      ),
                                    },
                                  }),
                                ]),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-footer justify-content-center" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary waves-effect waves-light",
                            attrs: { type: "button" },
                            on: { click: _vm.closeErrorLightbox },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.i18n.close) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }